import { useState, useEffect, useRef } from 'react';

const SCROLL_THRESHOLD = 10;  // px of movement before registering direction
const TOP_THRESHOLD = 80;     // always show header when within 80px of top

export const useScrollDirection = () => {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;

      // Always show near the top
      if (y < TOP_THRESHOLD) {
        setHidden(false);
        lastY.current = y;
        return;
      }

      // Ignore micro-jitter
      if (Math.abs(y - lastY.current) < SCROLL_THRESHOLD) return;

      setHidden(y > lastY.current);
      lastY.current = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return hidden;
};
